import { useEffect, useRef, useState } from "react";
import { useOidc } from "./oidcContext";
import { useLogin, checkLoggedIn } from "./authConfig";
import { LoginContext } from "./loginContext";
import Layout from "./pages/layout/Layout";

const LayoutWrapper = () => {
    const [loggedIn, setLoggedIn] = useState(false);
    const { userManager } = useOidc();
    // Keep track of the mounted state to avoid setting state in an unmounted component
    const mounted = useRef<boolean>(true);
    useEffect(() => {
        mounted.current = true;
        if (useLogin) {
            checkLoggedIn(userManager)
                .then(isLoggedIn => {
                    if (mounted.current) setLoggedIn(isLoggedIn);
                })
                .catch(e => {
                    console.error("checkLoggedIn failed", e);
                });
        }
        return () => {
            mounted.current = false;
        };
    }, [userManager]);

    return (
        <LoginContext.Provider value={{ loggedIn, setLoggedIn }}>
            <Layout />
        </LoginContext.Provider>
    );
};

export default LayoutWrapper;
